export default __webpack_public_path__ + "static/media/cat_2.93017e14.png";